import React, {useState} from "react";
import axios from "axios";
import Heading from "./heading";
import Social from "./social";
import ColorWheel from "./ColorWheel";

export default function Register(props){
    const [selectedColor, setSelectedColor] = useState('');
    const [message, changeMessage] = useState(false)
    const [user, changeUser] = useState(false)
    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        organization: '',
        username: '',
        password: '',
        newsletter: 'No',
        color: '',
      });

    function login(){
        const url = `/login?${new URLSearchParams({key1: parameterValue}).toString()}`;
        window.location.href = url
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNews = () => {
        if(formData.newsletter === "No"){
            setFormData({...formData, newsletter: "Yes"})
        }
        else if(formData.newsletter === "Yes"){
            setFormData({...formData, newsletter: "No"})
        }
    }

    const handleColorChange = (color) => {
        setSelectedColor(color);
    }

    const handleSubmit = (event) => {

        console.log(formData)
        if(formData.firstName !== '' && formData.lastName !== '' && selectedColor !== ''){
            //stopping atuomatic page reresh on form submission
            event.preventDefault();
            //sending form to backend(server)
            console.log(formData);
            const sendData = async () => {
                try {
                await axios.post('https://nvedemo24-backend-server.vercel.app/register',formData)
                .then((res) => {
                    console.log(res.data);
                    window.location.href = '/login';
                });
                } catch (err){
                    console.log(err)
                    if(err.response.status === 501){
                        changeUser(true)
                        changeMessage(false)
                    }
                }
            }
            sendData();
        }
        else{
            changeMessage(true)
        }
    };

    return(
        <>
            <Heading/>
            <h1 className="demo-heading" style={{fontSize: '32pt'}}>REGISTER</h1>
            <h1 className="demo-heading" style={{fontSize: '16pt', color: 'red' }}>YOUR DATA WILL NOT BE USED OUTSIDE OF COLORANTÍ</h1>
            <form className='form-container' onSubmit={handleSubmit}>
                <div className="login-container">
                <div className="left-register">
                    <div className="name-container"> 
                        <input className="name-input" placeholder="FIRST NAME" value={formData.firstName} id="firstName" name="firstName" onChange={handleChange}/>
                        <input className="name-input" placeholder="LAST NAME" value={formData.lastName} id="lastName" name="lastName" onChange={handleChange}/>
                    </div>
                    <input className="login-input" placeholder="EMAIL ADDRESS" value={formData.email} id="email" name="email" onChange={handleChange}/>
                    <input className="login-input" placeholder="ORGANIZATION" value={formData.organization} id="organization" name="organization" onChange={handleChange}/>
                    <input className="login-input" placeholder="USERNAME" value={formData.username} id="username" name="username" onChange={handleChange}/>
                    <input className="login-input" placeholder="PASSWORD" value={formData.password} id="password" name="password" onChange={handleChange}/>
                    <label for="option1" style={{fontSize: '18pt'}}>
                        <input type="checkbox" id="newsletter" value={formData.newsletter} onChange={handleNews}/>
                        Sign up for the Colorantí newsletter
                    </label>
                    <div className="login-button-container">
                        {message && <h1 className="user-taken">PLEASE FILL OUT THE FORM COMPLETELY</h1>}
                        {user && <h1 className="user-taken">USERNAME ALREADY TAKEN</h1>}
                        <button className="login-button" type="button" onClick={handleSubmit}>REGISTER</button>
                    <button className="left-text" type="button" onClick={login}>Already have an account? Click here to login</button>
                    </div>
                </div>
                    <div className="right-login">
                        <p className="right-text">CHOOSE YOUR LOGIN COLOR</p>
                        <ColorWheel
                            onChange={(color) => {
                                handleColorChange(color);
                                handleChange({ target: { name: "color", value: color } });
                            }}
                            value={formData.color}
                            name="color"
                            id="color"
                        />
                        <div className="color-container">
                        <p>Selected Color:</p>
                        <div className="selected-color" style={{ backgroundColor: selectedColor, border: "4px solid rgb(100, 100, 100)" }}></div>
                        </div>
                    </div>
                </div>
            </form>
            <Social/>
        </>
    )
}
